import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class PolicyService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  checkPolicyAgreement(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/policy/check-agreement`);
  }

  acceptPolicy(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/policy/accept`, {});
  }
}
